// The template picker's "other clients" section (2026-10-08): the same
// company's other Customer Service client libraries, below a bold divider,
// collapsed and grayed. The server decides which folders are in it
// (GET /api/templates/other-client-folders); these helpers only shape them.

// Whether the section (and its divider) shows at all.
export function showOtherClientSection(groups) {
  return Array.isArray(groups) && groups.some((g) => g?.folders?.length > 0)
}

// A subfolder's row text under its group header: "Cancel" for "1A Website/Cancel".
export function otherClientSubfolderLabel(group, folder) {
  return folder.startsWith(group.prefix) ? folder.slice(group.prefix.length) : folder
}

// The group a selected other-client folder belongs to, or null.
export function otherClientGroupOf(groups, folder) {
  return (groups ?? []).find((g) => g.folders.includes(folder)) ?? null
}

// The note above an other-client folder's templates.
export function otherClientNote(groups, folder) {
  const group = otherClientGroupOf(groups, folder)
  return group ? `Templates from ${group.label}, a different client than this contact. Check before sending.` : null
}
